import { type FC, type JSX } from 'react';
import Modal from '@mui/material/Modal';
import "./ActivityConsentFormUploaderDialog.scss";

interface ActivityConsentFormUploaderDialogProps {
    open: boolean,
    content: string | JSX.Element,
    onClose: () => void
}

export const ActivityConsentFormUploaderDialog: FC<ActivityConsentFormUploaderDialogProps> = (props) => {
    const { open, content, onClose } = props;

    return (
        <Modal open={open} onClose={onClose} className='dialog_wrapper activity_consent_uploader' role="dialog"
            aria-modal aria-labelledby="form_description_dialog_title" aria-describedby="form_description_dialog_content">
            <div className='dialog_surface'>
                <div className="dialog_content_wrapper"  id="form_description_dialog_content" aria-live="polite">
                    {content}
                </div>
            </div>
        </Modal>
    )
}